<template>
  <router-view #default="{ Component, route }">
  <keep-alive>
    <component :is="Component" :key="route.path" v-if="route.meta.keepAlive" />
  </keep-alive>
  <component :is="Component" v-if="!route.meta.keepAlive" />
</router-view>

</template>

<style lang="less">
#app {
font-size: 0.32rem /* 16/50 */;
}
</style>
